
/***
 * GERAL
 ***/
$(function() {
    $('.animsition').animsition().one('animsition.inStart',function(){
        App.SetToggle();
        App.SetGaleria();
        App.SetBanner();
        App.SetCarouselMobile();
        App.SetHeaderFixed(80);
        App.SetValidate();
        App.SetMaskInput();
        App.SetInputError();
        App.SetFormSuccess();
        App.SetAnimatescroll(150);
        App.SetWow(200);
        App.SetCookies();

        $('html').addClass('loaded');


        // carousel areas
        $('.Clientes .itens').each(function(index, el) {
            $(this).addClass('owl-carousel');
            $(this).owlCarousel({
                loop        : false,
                autoplay    : false,
                nav         : true,
                dots        : false,
                navText     : ['<i class="icon-left"></i>', '<i class="icon-right"></i>'],
                responsive  : {0:{items : 1},480:{items : 2},769:{items : 3},993:{items : 4}},
            });
        });

    });
});

  // Vídeo sobre ---
$(document).on('click', '.Video', function (event) {
    document.querySelector('.Video .box-video').insertAdjacentHTML('beforeend',videoSobre);
    event.preventDefault();
    $('.Video .image-box').addClass('_hide');
    var symbol = $('.box-video').find('iframe')[0].src.indexOf("?") > -1 ? "&" : "?";
    $('.box-video').find('iframe')[0].src += symbol + "autoplay=1";
});

// Animação Palavras
if ($('.palavra').length > 0) {
    const typedTextSpan = document.querySelector(".palavra");
    const cursorSpan = document.querySelector(".cursor");
    const text = $(typedTextSpan).attr('data-textos');
    const textArray = text.split(",");
    const typingDelay = 100;
    const erasingDelay = 50;
    const newTextDelay = 2000;
    let textArrayIndex = 0;
    let charIndex = 0;
    
    function type() {
      if (charIndex < textArray[textArrayIndex].length) {
        if(!cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
        typedTextSpan.textContent += textArray[textArrayIndex].charAt(charIndex);
        charIndex++;
        setTimeout(type, typingDelay);
      } 
      else {
        cursorSpan.classList.remove("typing");
        setTimeout(erase, newTextDelay);
      }
    }
    
    function erase() {
        if (charIndex > 0) {
        if(!cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
        typedTextSpan.textContent = textArray[textArrayIndex].substring(0, charIndex-1);
        charIndex--;
        setTimeout(erase, erasingDelay);
      } 
      else {
        cursorSpan.classList.remove("typing");
        textArrayIndex++;
        if(textArrayIndex>=textArray.length) textArrayIndex=0;
        setTimeout(type, typingDelay + 1100);
      }
    }
    
    document.addEventListener("DOMContentLoaded", function() { // On DOM Load initiate the effect
      if(textArray.length) setTimeout(type, newTextDelay + 250);
    });
}

$('#curriculo').on('change', function() {
    var filename = $('input[type=file]').val().split('\\').pop();
    $('#fileUploaded').remove();
    $(this).after('<span id="fileUploaded" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 400px;"><b>' + filename + '</b></span>');
});